import history from "./history";
import question from "./question";

export default {
    history,
    question
}